import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../assets/images/logocolor.png";
import sidelogo from "../../assets/images/sidehalflogo.png";
import "../../assets/fonts/Questrial-Regular-normal.js";
import "../../assets/fonts/Gabarito-VariableFont_wght-normal.js";

export const generatePdf = (prodname, data = []) => {
  if (!data || data.length === 0) {
    console.error("generatePdf: No data provided");
    return;
  }

  const doc = new jsPDF();

  // ------- Title --------
  //   doc.setFontSize(20);
  doc.setFontSize(30);
  doc.setFont("Gabarito-VariableFont_wght"); // or "times", "courier", etc.
  doc.setTextColor(43, 51, 140);
  doc.text(prodname, 14, 30);

  // Subtitle
  doc.setFont("Questrial-Regular"); // or "times", "courier", etc.
  doc.setFontSize(15);
  doc.setTextColor(10, 10, 10);
  doc.text("TECHNICAL DATA SHEET", 14, 38);

  // --- Group by specType ---
  const grouped = data.reduce((acc, item) => {
    if (!acc[item.specType]) acc[item.specType] = [];
    acc[item.specType].push(item);
    return acc;
  }, {});

  // ------- Subtitle or Branding -------
  //   doc.setFontSize(12);
  //   doc.text("Generated via React", 14, 30);

  // ------- Convert Array of Objects to Table -------
  //   const columns = Object.keys(data[0]).map((key) => ({
  //     header: key.toUpperCase(),
  //     dataKey: key,
  //   }));
  doc.setFontSize(15);
  doc.setFont("helvetica", "bold"); // or "times", "courier", etc.
  doc.setTextColor(0, 0, 0);
  // --- Create one section per group ---
  Object.entries(grouped).forEach(([type, items]) => {
    // Section title (Chemical, Physical, etc.)
    doc.text(type, 14, doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 60);
    doc.setLineWidth(0.25); // optional (default is very thin)
    doc.line(
      14,
      doc.lastAutoTable ? doc.lastAutoTable.finalY + 12 : 62,
      110,
      doc.lastAutoTable ? doc.lastAutoTable.finalY + 12 : 62
    ); // x1, y1, x2, y2
    autoTable(doc, {
      // columns,
      head: [],
      body: items.map((item) => [item.specName, item.specValue]),
      startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 15 : 65,
      tableWidth: 100,
      styles: {
        fontSize: 11,
        cellPadding: 1,
      },
      alternateRowStyles: { fillColor: null },
      // headStyles: {
      //   //   fillColor: [0, 102, 204],
      //   textColor: 255,
      //   fontStyle: "bold",
      // },
    });
  });

  // Slogan
  doc.setFontSize(25);
  doc.setFont("Gabarito-VariableFont_wght", "normal"); // or "times", "courier", etc.
  doc.text(["Grow Sustainable.", "Grow With Us."], 14, 240);

  // Footer
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(
    [
      "Agroderivados y quiimicos, WeGrow S.L.",
      "C/Maldonado 15, 28006, Madrid, Spain",
      "Tlf +34 9177816449",
      "info@wegrowagro.com",
      "www.wegrowagro.com",
    ],
    14,
    270
  );

  doc.addImage(logo, "PNG", 158, 265, 40, 22);
  doc.addImage(sidelogo, "PNG", 135, 58, 85, 180);

  doc.save(prodname + ".pdf");
};
